<template>
   <!-- <div class="d-flex justify-content-center align-items-center min-vh-100"> -->
  <b-container
    :fluid="true"
    class="px-0"
    :style="{ margin: (loading || error) ? '0 !important' : 'auto'}"
    v-cloak
  >
    <form @submit.prevent="valid">
      <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
        <Loading />
      </div>
      <div v-else-if="error"
      class="min-vh-100 d-flex align-items-center justify-content-center">
        <div style="max-width: 400px;">
          <h4 class="text-2xl text-gray-500 font-weight-bold">
            Shipment Not Found
          </h4>
          <p class="text-gray-700">
            Invoice # <span class="badge badge-primary">{{ this.response.id}}</span> could
            not be found. Make sure that there are no typos in the shipment id.
          </p>
          <b-button
            class="d-flex align-items-center mx-auto"
            @click="$router.go(-1)"
          >
            <b-icon-chevron-left font-scale="0.8" />
            BACK
          </b-button>
        </div>
      </div>
      <div v-else-if="success"
      class="min-vh-100 d-flex align-items-center justify-content-center">
        <div style="max-width: 400px;">
          <h4 class="text-2xl text-gray-500 font-weight-bold">
            Shipment Updated successfully
          </h4>
          <p class="text-gray-700">
            Invoice # <span class="badge badge-primary">{{ this.response.id}}</span> has
            updated successfully.
          </p>
          <b-button
            class="d-flex align-items-center mx-auto"
            @click="$router.go(-1)"
          >
            <b-icon-chevron-left font-scale="0.8" />
            BACK
          </b-button>
        </div>
      </div>
      <fieldset v-else>
        <!-- <b-row class="px-3"> -->
          <!-- <b-col
            cols="auto"
            class="pr-0 position-fixed d-none d-md-flex align-items-center"
            style="top: 10px; z-index: 1; height: calc(100vh - 20px);"
          >
          </b-col> -->
          <!-- <b-col class="col ml-md-5" lg="8" id="content"> -->
            <CustomerPrototypeCard name="invoice">
              <template v-slot:title>
                <h6>INVOICE # {{ response.id }}</h6>
              </template>
              <template v-slot:body>
                <div class="mx-3">
                  <hr class="mx-4 my-4"/>
                  <ShipmentNextStatus
                    :current-status="response.movementStatus"
                    :container="response.container"
                  ></ShipmentNextStatus>
                </div>
              </template>
            </CustomerPrototypeCard>
            <fieldset :disabled="true">
            <CustomerPrototypeCard name="SENDER" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>SENDER</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="shipper-Name"
                  >Name</label>
                  <input
                    required
                    class="form-control text-center"
                    id="shipper-Name"
                    name="shipper-Name"
                    type="text"
                    v-model="response.shipperName"
                  >
                </div>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="shipper-address"
                  >Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="shipper-address"
                    name="shipper-address"
                    type="text"
                    v-model="response.shipper.address"
                  >
                </div>
                <div class="floating-label-container">
                  <input
                    required
                    class="form-control text-center"
                    id="shipper-address2"
                    name="shipper-address2"
                    type="text"
                    v-model="response.shipperaddress2"
                  >
                </div>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="shipper-country"
                  >Country</label>
                  <input
                    required
                    class="form-control text-center"
                    id="shipper-country"
                    name="shipper-country"
                    type="text"
                    v-model="response.shipper.country"
                  >
                </div>
              </div>
            </template>
          </CustomerPrototypeCard>
        </fieldset>
        <fieldset :disabled="true">
            <CustomerPrototypeCard name="consignee" v-observe-visibility="visibilityChanged"
            :disabled="true">
            <template v-slot:title>
              <h6>CONSIGNEE</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="shipper-Name"
                  >Name</label>
                  <input
                    required
                    class="form-control text-center"
                    id="shipper-Name"
                    name="shipper-Name"
                    type="text"
                    v-model="response.consigneeName"
                  >
                </div>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="consignee-address"
                  >Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-address"
                    name="consignee-address"
                    type="text"
                    v-model="response.consignee.address"
                  >
                </div>
                <div class="floating-label-container">
                  <!-- <label
                    class="col-form-label floating-label active"
                    for="consignee-address"
                  >Address</label> -->
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-address"
                    name="consignee-address"
                    type="text"
                    v-model="response.consigneaddress2"
                  >
                </div>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label active"
                    for="consignee-country"
                  >Country</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-country"
                    name="consignee-country"
                    type="text"
                    v-model="response.consignee.country"
                  >
                </div>
              </div>
            </template>
          </CustomerPrototypeCard>
        </fieldset>
          <CustomerPrototypeCard v-if="response.movementStatus == 'toload'" name="container">
              <template v-slot:title>
                <h6>CONTAINER #</h6>
              </template>
              <template v-slot:body>
              <div class="mx-5 pb-3">
                <div class="floating-label-container">
                  <b-form-select
                      required
                      :disabled="isDisabled"
                      id="delivery-type"
                      v-model="response.container.name"
                      :options="container"
                      class="text-center"
                    ></b-form-select>
                </div>
              </div>
              </template>
            </CustomerPrototypeCard>
            <fieldset :disabled="true">
            <CustomerPrototypeCard
            v-if="response.movementStatus !== 'toload' && response.movementStatus !== 'pickup'"
            name="container">
              <template v-slot:title>
                <h6>CONTAINER #</h6>
              </template>
              <template v-slot:body>
              <div class="mx-5 pb-3">
                <div class="floating-label-container">
                  <input
                    required
                    class="form-control text-center"
                    id="container-Name"
                    name="container-Name"
                    type="text"
                    v-model="response.container.name"
                  >
                </div>
              </div>
              </template>
            </CustomerPrototypeCard>
          </fieldset>
            <fieldset :disabled="true">
          <CustomerPrototypeCard name="items" v-observe-visibility="visibilityChanged"
          :disabled="true">
            <template v-slot:title>
              <div class="position-relative d-flex justify-content-center align-items-center">
                <h6>ITEMS</h6>
              </div>
            </template>
            <template v-slot:body>
              <ClientPrototypeItemList
                :items="response.itemDetails.items"
                @add="addNewItem"
                @remove="removeItem"
                @toggleHazard="toggleHazard"
                @updateSeal="updateSeal"
              ></ClientPrototypeItemList>
            </template>
          </CustomerPrototypeCard>
        </fieldset>
          <!-- <CustomerPrototypeCard name="payments"
          v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>PAYMENTS</h6>
            </template>
            <template v-slot:body>
              <CustomerPaymentList
                :items="response.payments"
              ></CustomerPaymentList>
            </template>
          </CustomerPrototypeCard>
          <CustomerPrototypeCard name="summary"  v-observe-visibility="visibilityChanged">
              <template v-slot:title>
                <h6>Outstanding Balance</h6>
              </template>
              <template v-slot:body>
                <div>
                  ${{ outstandingBalance }}
                </div>
              </template>
          </CustomerPrototypeCard> -->
          <!-- </b-col> -->
        <!-- </b-row> -->
        <CustomerPrototypeCard name="submit" v-observe-visibility="visibilityChanged"
        v-if="response.movementStatus !== 'completed'">
            <!-- <template v-slot:title>
              <h6>FINAL STEP</h6>
            </template> -->
            <template v-slot:body>
              <b-button type="submit" block class="mb-2 shipment-create-button m-auto"
              :disabled="isDisabled">
                <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                UPDATE STATUS
              </b-button>
            </template>
          </CustomerPrototypeCard>
    </fieldset>
    <b-modal id="confirmation" ref="confirmationModal" centered title="" hide-footer
        hide-header :no-close-on-backdrop="true">
          <div v-if="processing">
            <Loading />
          </div>
          <div v-else-if="processingError">
            <div class="d-flex align-items-center justify-content-center">
              <Cross />
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <h2>Failure</h2>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              {{ processingError }}
            </div>
          </div>
          <div v-else>
            <div class="d-flex align-items-center justify-content-center">
              <Checkmark />
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <h2>Done!</h2>
            </div>
          </div>
        </b-modal>
    </form>
  </b-container>
<!-- </div> -->
</template>

<script>
import _ from 'lodash';
import { nanoid } from 'nanoid';
import moment from 'moment';
import 'moment-timezone';
import 'vue-select/dist/vue-select.css';

import CustomerPrototypeCard from '../components/CustomerPrototypeCard.vue';
// import CustomerPaymentList from '../components/CustomerPaymentList.vue';
import ClientPrototypeItemList from '../components/ClientPrototypeItemList.vue';
import ShipmentNextStatus from '../components/ShipmentNextStatus.vue';
import Loading from '../components/Loading.vue';

import {
  getEmployeeShipmentById,
  updateShipmentItem,
  updateShipmentStatus,
} from '../api/shipment';

import { getContainer } from '../api/manifest';

export default {
  name: 'UpdateShipmentStatus',
  data() {
    return this.initialState();
  },
  computed: {
    mostCommonReference() {
      const counter = {};
      this.response.itemDetails.items.forEach((elem) => {
        if (elem.description in counter) {
          counter[elem.description] += 1;
        } else {
          counter[elem.description] = 1;
        }
      });

      let max = -1;
      let maxRef = '';
      Object.entries(counter).forEach(([key, val]) => {
        if (val >= max) {
          maxRef = key;
          max = val;
        }
      });
      return max === -1 ? '' : `${maxRef}...`;
    },
    totalCount() {
      // return this.response.itemDetails.items.length;
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.qty, 0);
    },
    totalWeight() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.weight * curr.qty, 0);
    },
    totalVolume() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.volume * curr.qty, 0);
    },
    outstandingBalance() {
      return this.response.chargeDetails.charges.reduce((acc, curr) => acc + curr.amount, 0)
        - this.response.payments.reduce((acc, curr) => acc + curr.amount, 0);
    },
    backToSearch() {
      return this.accountNumber || this.phoneNumber || this.name || this.destination;
    },
    formattedPickupStart() {
      return this.response.pickupDetails.pickupStartTime.toLocaleString('en-US', { timeStyle: 'short' });
    },
    formattedPickupEnd() {
      return this.response.pickupDetails.pickupEndTime.toLocaleString('en-US', { timeStyle: 'short' });
    },
    minEndDate() {
      return this.response.pickupDetails.pickupStartTime;
    },
    maxStartDate() {
      return this.response.pickupDetails.pickupEndTime;
    },
  },
  methods: {
    initialState() {
      return {
        isDisabled: true,
        pickupStartTime: null,
        pickupEndTime: null,
        dateCreated: '',
        isStartDateValid: null,
        isEndDateValid: null,
        isStartTimeValid: null,
        isEndTimeValid: null,
        container: [],
        response: {
          id: '',
          container: {},
          shipper: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            airportCode: '',
            email: '',
            phone: '',
          },
          consignee: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            airportCode: '',
            email: '',
            phone: '',
          },
          agent: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            airportCode: '',
            email: '',
            phone: '',
          },
          pickupDetails: {
            driver: '',
            address: '',
            city: '',
            state: '',
            zipCode: '',
            pickupStartTime: null,
            pickupEndTime: null,
            pickupNote: '',
            pickupRemark: '',
            pickupMode: 'pickup',
            container: '',
          },
          itemDetails: {
            flag: '',
            shippingTerm: null,
            travelMode: null,
            items: [
              {
                id: 0,
                qty: 1,
                packageType: '',
                description: '',
                weight: 0,
                volume: 0,
                length: 0,
                width: 0,
                height: 0,
                // seal: '',
                seal: [
                  { id: nanoid(6), value: '', flag: true },
                ],
                hazardous: false,
                flag: true,
                selectedWeightType: 'lbs',
                optionsWeightType: [
                  { value: 'lbs', text: 'lbs' },
                  // { value: 'kgs', text: 'kgs' },
                  // { value: 'tons', text: 'tons' },
                ],
                selectedVolumeType: 'in3',
                optionsVolumeType: [
                  { value: 'in3', text: 'in3' },
                  // { value: 'm3', text: 'meters3' },
                ],
                selectedMeasureType: 'in',
                optionsMeasureType: [
                  { value: 'in', text: 'in' },
                  // { value: 'm', text: 'meters' },
                ],
              },
            ],
          },
          chargeDetails: {
            charges: [
              {
                id: 0,
                name: 'Freight',
                amount: 0,
                flag: true,
              },
              {
                id: 1,
                name: 'Pickup',
                amount: 0,
                flag: true,
              },
              {
                id: 2,
                name: 'Handling',
                amount: 0,
                flag: true,
              },
              {
                id: 3,
                name: 'Insurance',
                amount: 0,
                flag: true,
              },
            ],
          },
          payments: [],
          movementStatus: '',
        },
        accountNumber: '',
        bol: '',
        phoneNumber: '',
        name: '',
        destination: '',
        print: false,
        loading: true,
        processing: false,
        processingError: '',
        error: false,
        success: false,
      };
    },
    valid() {
      let flag = false;

      if (this.response.movementStatus === 'todeliver' && this.outstandingBalance < 0) {
        flag = true;
        this.processingError = 'Can not have a negative outstanding balance';
        this.$refs.confirmationModal.show();
        setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
      }

      if (flag) {
        return;
      }
      this.UpdateShipment();
    },
    UpdateShipment() {
      this.processing = true;
      this.processingError = '';
      this.$refs.confirmationModal.show();
      const data = {
        data: {
          shipmentId: this.response.id,
          container: this.response.container.name,
        },
      };
      updateShipmentStatus(data).then((resp) => {
        this.response.movementStatus = resp.data.status;
        this.response.itemDetails.items.map((item) => (
          Object.assign(item,
            {
              completed: false,
            })
        ));
        this.processing = false;
        setTimeout(() => this.$refs.confirmationModal.hide(), 1000);
        this.success = true;
      }).catch((err) => {
        this.processingError = err.response.data.error;
        this.processing = false;
        setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
      });
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();

    if (this.$route.params.id) {
      const data = { data: { id: this.$route.params.id } };
      updateShipmentItem(data).then((resp) => {
        getEmployeeShipmentById(resp.data.shipmentId)
          .then((res) => {
            this.response = res.data.result;

            this.response.shipper = Object.fromEntries(Object.entries(this.response.shipper)
              .map(([k, v]) => [k, v.toUpperCase()]));
            this.response.consignee = Object.fromEntries(Object.entries(this.response.consignee)
              .map(([k, v]) => [k, v.toUpperCase()]));
            this.response.shipperName = `${this.response.shipper.firstName} ${this.response.shipper.lastName}`;
            this.response.consigneeName = `${this.response.consignee.firstName} ${this.response.consignee.lastName}`;
            this.response.shipperaddress2 = `${this.response.shipper.city}, ${this.response.shipper.state} ${this.response.shipper.zipCode}`;
            this.response.consigneaddress2 = `${this.response.consignee.city}, ${this.response.consignee.state} ${this.response.consignee.zipCode}`;
            this.response.payments = this.response.payments.map((p) => ({
              ...p,
              paidDate: new Date(p.paidDate).toISOString().split('T')[0],
              paymentMethod: p.paymentMethod.toUpperCase(),
              amount: +p.amount,
            }));
            this.response.chargeDetails.charges = this.response.chargeDetails.charges
              .map((charge) => ({
                ...charge,
                amount: +charge.amount,
              }));

            this.response.pickupDetails.pickupStartTime = moment.tz(
              this.response.pickupDetails.pickupStartTime,
            );
            this.response.pickupDetails.pickupEndTime = moment.tz(
              this.response.pickupDetails.pickupEndTime,
            );

            this.pickupStartTime = this.response.pickupDetails.pickupStartTime.format('HH:mm:ss');
            this.pickupEndTime = this.response.pickupDetails.pickupEndTime.format('HH:mm:ss');
            this.response.pickupDetails.pickupStartTime = this.response.pickupDetails.pickupStartTime.format('YYYY-MM-DD');
            this.response.pickupDetails.pickupEndTime = this.response.pickupDetails.pickupEndTime.format('YYYY-MM-DD');

            this.dateCreated = new Date(this.response.pickupDetails.dateCreated).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' });
            // this.response.itemDetails.shippingTerm = this.response.itemDetails.type;
            // delete this.response.itemDetails.type;
            // Fix mismatching enum response
            this.response.itemDetails.shippingTerm = this.response.itemDetails.shippingTerm === 'moved' ? _.camelCase('door to door') : _.camelCase(this.response.itemDetails.shippingTerm);
            this.response.movementStatus = this.response.movement_status;
            delete this.response.movement_status;
            // Fill missing API values
            this.response.itemDetails.items = this.response.itemDetails.items.map((item) => ({
              ...item,
              packageType: item.packageType.toUpperCase(),
              description: item.description.toUpperCase(),
              hazardous: !!item.hazardous,
              selectedWeightType: 'lbs',
              optionsWeightType: [
                { value: 'lbs', text: 'lbs' },
                // { value: 'kgs', text: 'kgs' },
                // { value: 'tons', text: 'tons' },
              ],
              selectedVolumeType: 'in3',
              optionsVolumeType: [
                { value: 'in3', text: 'in3' },
                // { value: 'm3', text: 'meters3' },
              ],
              selectedMeasureType: 'in',
              optionsMeasureType: [
                { value: 'in', text: 'in' },
                // { value: 'm', text: 'meters' },
              ],
            }));

            if (this.response.itemDetails.items.find((item) => (item.completed !== true))) {
              this.isDisabled = true;
            } else {
              this.isDisabled = false;
            }
            // Correct typo in response
            this.response.movementStatus = this.response.movementStatus === 'Delivering' ? 'Shipping' : this.response.movementStatus;
            getContainer(this.response.consignee.country.toLowerCase()).then((containerResp) => {
              const containerResults = containerResp.data.results.map((item) => (
                Object.assign(item,
                  {
                    value: item.id,
                    text: item.name.toLowerCase().trim(),
                  })
              ));
              this.container = containerResults;
            });
            this.loading = false;
            this.error = false;
          })
          .catch(() => {
            this.loading = false;
            this.error = true;
          });
        // }).catch(() => {
        //   this.loading = false;
        //   this.error = true;
        // });
      }).catch(() => {
        this.loading = false;
        this.error = true;
      });
    } else {
      this.loading = false;
      this.error = true;
    }
  },
  components: {
    Loading,
    ShipmentNextStatus,
    // CustomerPaymentList,
    ClientPrototypeItemList,
    CustomerPrototypeCard,
  },
};
</script>

<style scoped lang="scss">
@import '../assets/styles/floatingLabel.scss';

#pdf {
  width: 100%;
  height: 100%;
}

.shipment-option {
  height: 3em;
  width: 3em;
  padding: 0;
  border-radius: 50%;
  margin: 0 10px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  background: #7da3c7;
  outline: none;
  border: none;
}

.shipment-option:hover {
  background: #608cb3;
}

.shipment-create-button {
  background: #7da3c7;
  border: none;
}

.shipment-create-button:hover {
  background: #608cb3;
}

.normalize {
  outline: none;
  box-shadow: none;
  background-color: transparent;
  border: none;
  padding-left: 0;
  padding-right: 0;
}

.normalize:focus, .normalize:active {
  outline: none;
  box-shadow: none !important;
  background-color: transparent !important;
  border: none;
}

.shipment-list-item {
  padding: 10px 0;
  color: #4c4c4c;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shipment-list-item:hover {
  background: #f5f5f5;
  border-radius: 0;
}

h6, h5 {
  margin-bottom: 0;
}

#shipment-scrollspy li {
  position: relative;
}

#shipment-scrollspy li:after {
  content: '.';
  display: block;
  position: absolute;
  top: 0.35em;
  right: 5px;
}

[v-cloak] {
  display: none;
}

::v-deep .b-time {
  width: 100%;
}
</style>

<style>
html {
  scroll-behavior: smooth;
}

.left-15 {
  left: 15px;
}
</style>
